import React from "react";
import { BRAND } from "@/config/brand";

// `onDark` swaps to the background-removed (transparent) artwork.
// Light surfaces keep the original seal with its white circular backing.
export const GpuMark = ({ className = "h-10 w-10", size = "sm", onDark = false, priority = false, decorative = false }) => {
  const set = onDark ? BRAND.logoTransparent : BRAND.logo;
  const key = { xs: "xs", sm: "sm", md: "lg", lg: "xl" }[size] || "sm";
  return (
    <img
      src={set[key]}
      alt={decorative ? "" : BRAND.logoAlt}
      aria-hidden={decorative ? "true" : undefined}
      width={512}
      height={512}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      className={`${className} shrink-0 select-none object-contain`}
      draggable="false"
    />
  );
};

export const GpuLogo = ({ surface = "light", compact = false }) => {
  const onDark = surface === "dark";
  return (
    <span className="flex items-center gap-2.5 sm:gap-3">
      <GpuMark
        className={compact ? "h-10 w-10 sm:h-11 sm:w-11" : "h-12 w-12"}
        size="sm"
        onDark={onDark}
        priority
      />
      <span className="flex min-w-0 flex-col leading-none">
        <span
          className={`whitespace-nowrap font-display font-bold leading-none tracking-tight ${
            compact ? "text-[13px] sm:text-[15px]" : "text-lg"
          } ${onDark ? "text-white" : "text-navy"}`}
        >
          GUJARAT PHARMA UNION
        </span>
        <span
          className={`mt-1.5 whitespace-nowrap font-mono text-[7px] uppercase tracking-[0.18em] sm:text-[8px] ${
            onDark ? "text-gold" : "text-grn"
          }`}
        >
          Unity · Compliance · Protection
        </span>
      </span>
    </span>
  );
};
